import TimePicker from './time_picker';
import Pikaday from 'pikaday';

// `DateTimeRangeHint` shows a datetime-range-picker hint.
export default class DateTimeRangeHint {
  constructor($el, $container, token, params, query) {
    this.$el = $el;
    this.$container = $container;
    this.token = token;
    this.params = params;
    this.query = query;

    this.pickers = {};

    this.$container.html(this.params.template);

    const [start, end] = this.token.value().split(/ TO /);
    this.insertPicker(start.substring(1), '.picker-start');
    this.insertPicker(end.substring(-1), '.picker-end');

    this.showOrHideTimePickers();
    this.$container.show();
  }

  insertPicker(dateStr, el) {
    let [dateText, timeText, zoneText] = dateStr.split(/\s/, 3);
    const date = this.textToDateInUserZone(dateText);
    if (timeText && !timeText.match(/^\d?\d:\d\d$/)) {
      timeText = null;
    }
    if (zoneText && !zoneText.match(/^UTC[-+]?\d{0,3}$/)) {
      zoneText = null;
    }

    this.pickers[el] = {};
    this.pickers[el].date = new Pikaday({
      onSelect: () => this.onDateTimeChange(),
      setDefaultDate: true,
      keyboardInput: false,
      defaultDate: date,
    });

    this.pickers[el].time = new TimePicker(timeText, zoneText, () =>
      this.onDateTimeChange(),
    );

    this.$container
      .find(el)
      .append(this.pickers[el].date.el)
      .append(this.pickers[el].time.el);
  }

  textToDateInUserZone(dateText) {
    // The date needs to be in the user's timezone to keep pikaday happy
    if (dateText.match(/^\d\d\d\d-\d\d-\d\d$/)) {
      const date = new Date(dateText);
      date.setHours(date.getHours() + date.getTimezoneOffset() / 60);
      return date;
    }
    return null;
  }

  onDateTimeChange() {
    this.showOrHideTimePickers();
    const [startTime, endTime] = Object.values(this.pickers).map(
      ({ date, time }) => {
        if (!date.getDate()) {
          date.setDate(new Date());
        }
        return [date.toString(), time.time(), time.zone()]
          .filter(f => f)
          .join(' ');
      },
    );

    this.query.replaceToken(
      this.token.cloneWithNewValue(`[${startTime} TO ${endTime}]`),
    );
  }

  setToken(token) {
    this.token = token;
  }

  destroy() {
    Object.values(this.pickers).forEach(({ date, time }) => {
      date.destroy();
      time.destroy();
    });

    this.pickers = {};
  }

  showOrHideTimePickers() {
    Object.values(this.pickers).forEach(({ time, date }) => {
      if (date.getDate()) {
        time.show();
      } else {
        time.hide();
      }
    });
  }
}
